import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Je bericht is verzonden. Dank je wel.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-sand-300 focus:border-terracotta-500 outline-none py-3 font-sans text-base font-light text-sand-900 placeholder:text-sand-900/40 transition-colors duration-300";

  return (
    <section id="contact" data-testid="contact-section" className="py-28 sm:py-36 bg-sand-100/50">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16 lg:gap-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <p className="font-sans text-xs font-light tracking-[0.35em] uppercase text-terracotta-500 mb-6">
            04 — Contact
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-sand-900 leading-tight">
            Schrijf me <em className="text-terracotta-500">een brief</em>
          </h2>
          <p className="mt-8 max-w-sm font-sans text-base font-light leading-relaxed text-sand-900/70">
            Een reactie op een lied, een gedachte over een verhaal, een uitnodiging
            om te spelen — alles mag. Ik lees en beantwoord alles zelf.
          </p>
        </motion.div>

        <motion.form
          onSubmit={submit}
          data-testid="contact-form"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="space-y-8 self-center w-full"
        >
          <input
            type="text"
            required
            value={form.name}
            onChange={set("name")}
            placeholder="Je naam"
            data-testid="contact-name-input"
            className={inputCls}
          />
          <input
            type="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="Je e-mailadres"
            data-testid="contact-email-input"
            className={inputCls}
          />
          <textarea
            required
            rows={4}
            value={form.message}
            onChange={set("message")}
            placeholder="Je bericht"
            data-testid="contact-message-input"
            className={`${inputCls} resize-none`}
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="contact-submit-button"
            className="font-sans text-xs font-light tracking-[0.25em] uppercase text-sand-50 bg-terracotta-500 hover:bg-terracotta-600 disabled:opacity-50 transition-colors duration-300 px-10 py-4 rounded-full"
          >
            {busy ? "Versturen…" : "Verstuur"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
